/***********loading显示与隐藏************/
export const SPIN_SHOW = 'SPIN_SHOW';
export const SPIN_HIDE = 'SPIN_HIDE';



// WEBPACK FOOTER //
// ./src/constants/index.js